import moment, { Moment } from "moment";
import { SocialPost } from "../../../cores/socialPost/interfaces/api/get-social-posts";

const STATUS_PUBLISHED = 1;

/**
 * Momento a usar en el calendario: pendientes/programados priorizan scheduleDate
 * (minuto exacto elegido); publicados usan postAt.
 * Evita que un postAt enviado o parcial (común en imágenes) tape la hora programada.
 */
export function getSocialPostCalendarMoment(post: SocialPost): Moment {
  const p = post.post;
  const scheduled = p.scheduleDate ? moment(p.scheduleDate) : moment.invalid();
  const posted = p.postAt ? moment(p.postAt) : moment.invalid();

  if (p.status === STATUS_PUBLISHED) {
    if (posted.isValid()) return posted;
    if (scheduled.isValid()) return scheduled;
    return posted;
  }
  if (scheduled.isValid()) return scheduled;
  if (posted.isValid()) return posted;
  return moment.invalid();
}
